var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKh = function SvgKh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b25eeda-34ee-4a24-9405-bfbc9cd82715a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1ac5cf32-5bba-499b-a56e-253ad3362a63b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1ac5cf32-5bba-499b-a56e-253ad3362a63b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3001A",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 5h.5L9 6H8zm1 1h1v1H9zM8 7h1v1H8zM7 8h1v1H7zm0 1h1v1H7zm-.5 0H7v1H6zM9 8h2v2H9zm4-3h-.5L12 6h1zm-1 1h-1v1h1zm1 1h-1v1h1zm1 1h-1v1h1zm0 1h-1v1h1zm.5 0H14v1h1zM12 8h-1v2h1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DDE0",
    fillRule: "evenodd",
    d: "M9 7h1v1H9zM8 8h1v2H8zm0-2h1v1H8zm-.5 1H8v1H7zM12 7h-1v1h1zm1 1h-1v2h1zm0-2h-1v1h1zm.5 1H13v1h1zM11 6h-1v2h1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    fillRule: "evenodd",
    d: "M10 5h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0028A4",
    fillRule: "evenodd",
    d: "M0 0h21v4H0zm0 11h21v4H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0b25eeda-34ee-4a24-9405-bfbc9cd82715a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgKh;